import { useState } from "react";
import { ReferralShareData } from "./util";

type UseShareBoard = {
  openShareBoard: () => Promise<void>;
  handelCustomShareModalClose: () => void;
  isCustomShareModalOpen: boolean;
};

export function useShareBoard(shareData: ReferralShareData): UseShareBoard {
  const [isCustomShareModalOpen, setIsCustomShareModalOpen] = useState(false);

  const openShareBoard = async () => {
    try {
      const { title, url, text } = shareData;
      await window.navigator.share({ title, url, text });
    } catch (err) {
      if (!/abort|canceled/gi.test(err.message)) {
        // show social share board
        setIsCustomShareModalOpen(true);
      }
    }
  };

  const handelCustomShareModalClose = () => setIsCustomShareModalOpen(false);

  return {
    openShareBoard,
    handelCustomShareModalClose,
    isCustomShareModalOpen
  };
}
